<template>
	<div class="socials-wrapper" v-if="$route.name !== 'TestResult' && $route.name !== 'TestInner'">
		<ul class="social-list">
			<li class="social-item">
				<a href="#" @click="share('tw')" class="social-link tw">
					<tw></tw>
				</a>
			</li>
			<li class="social-item">
				<a href="#" @click="share('fb')" class="social-link fb">
					<fb></fb>
				</a>
			</li>
			<li class="social-item">
				<a href="#" @click="share('vk')" class="social-link vk">
					<vk></vk>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
	import tw from '@/assets/svg/tw.svg';
	import fb from '@/assets/svg/fb.svg';
	import vk from '@/assets/svg/vk.svg';
	import Helpers from '@/tools/Helpers'

	export default {
		name: 'Socials',
		data() {
			return {
				Helpers,
				url: encodeURIComponent(window.location.protocol + '//' + window.location.host),
			}
		},
		components: {
			tw,
			fb,
			vk,
			Helpers
		},
		methods: {
			share(sn) {
				let url = this.url;
				Helpers.ga().send('click','share ' + sn);
				Helpers.share(sn, url);
			},
		}
	}
</script>



// WEBPACK FOOTER //
// Socials.vue?0169486a